"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const icon_1 = require("../../shared/typography/icon");
const Rectangle = (props) => {
    return ((0, jsx_runtime_1.jsx)(RectangleWrapper, { onClick: props.onClick, color: props.color, className: props.className, children: props.children ? (props.children) : ((0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: props.icon, size: props.size || "1x" }, void 0)) }, void 0));
};
const RectangleSmall = (props) => {
    return ((0, jsx_runtime_1.jsx)(RectangleSmallWrapper, { onClick: props.onClick, color: props.color, className: props.className, children: props.children ? (props.children) : ((0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: props.icon, size: props.size || "sm" }, void 0)) }, void 0));
};
const RectangleBig = (props) => {
    return ((0, jsx_runtime_1.jsx)(RectangleBigWrapper, { onClick: props.onClick, color: props.color, className: props.className, children: props.children ? (props.children) : ((0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: props.icon, size: props.size || "lg" }, void 0)) }, void 0));
};
const Circle = (props) => {
    return ((0, jsx_runtime_1.jsx)(CircleWrapper, { onClick: props.onClick, color: props.color, className: props.className, children: props.children ? (props.children) : ((0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: props.icon, size: props.size || "1x" }, void 0)) }, void 0));
};
const CircleSmall = (props) => {
    return ((0, jsx_runtime_1.jsx)(CircleSmallWrapper, { onClick: props.onClick, color: props.color, className: props.className, children: props.children ? (props.children) : ((0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: props.icon, size: props.size || "1x" }, void 0)) }, void 0));
};
const RectangleWrapper = (0, styled_components_1.default)(icon_1.Icon) `
  height: 1.5rem;
  width: 1.5rem;
`;
const RectangleSmallWrapper = (0, styled_components_1.default)(icon_1.Icon) `
  display: inline-block;
  height: auto;
  width: auto;
`;
const RectangleBigWrapper = (0, styled_components_1.default)(icon_1.Icon) `
  padding: 0.625rem;
`;
const CircleWrapper = (0, styled_components_1.default)(RectangleWrapper) `
  border-radius: 50%;
`;
const CircleSmallWrapper = (0, styled_components_1.default)(RectangleSmallWrapper) `
  border-radius: 50%;
`;
const Icons = {
    rectangle: Rectangle,
    rectangleSmall: RectangleSmall,
    rectangleBig: RectangleBig,
    circle: Circle,
    circleSmall: CircleSmall
};
exports.Icon = (0, react_1.memo)(({ ...props }) => {
    return (0, react_1.createElement)(Icons[props.shape], props);
});
//# sourceMappingURL=Icon.js.map